import React, { FunctionComponent } from 'react';

import { find } from 'lodash';
import { Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { Template } from 'common/templates/Templates';

import 'reviews2/feed/review-yeti/reply/editor/custom-elements/CustomTemplateLabel.scss';

interface RenderSentimentProps {
    sentiment: string;
}

const Sentiment: FunctionComponent<RenderSentimentProps> = ({ sentiment }) => {
    const { t } = useTranslation('reviews2');
    const sentimentLowerCase = sentiment.toLowerCase();
    const sentimentUpperCase = sentiment.toUpperCase();

    return <Badge variant={`sentiment-${sentimentLowerCase}`}>{t(sentimentUpperCase)}</Badge>;
};

export const CustomTemplateLabel = (item: Template): JSX.Element => {
    const sentimentOrder = ['Positive', 'Neutral', 'Negative'];
    const sentiments = find(item.labels as any, { labelType: 4 });
    const sortedValues = sentiments?.values?.toSorted((a: string, b: string) => {
        return sentimentOrder.indexOf(a) - sentimentOrder.indexOf(b);
    });

    return (
        <div className="r4e-review-custom-template-label">
            <span className="name">{item.name}</span>
            {sortedValues?.map((sentiment: string) => {
                return <Sentiment sentiment={sentiment} />;
            })}
        </div>
    );
};
